import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorTransactionReturSearch = () => {
  const transactionReturSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/retur-header/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { transactionReturSearch }
}

export default InteractorTransactionReturSearch
